var React = require('react');

function ArrowRoundedLeft8x13 (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M7.7,12.7L7.7,12.7c-0.4,0.4-0.9,0.4-1.3,0L0,6.5l6.4-6.2c0.4-0.4,0.9-0.3,1.3,0l0,0c0.4,0.4,0.4,1,0,1.3l-5,4.9l5,4.9\r\n\tC8.1,11.8,8.1,12.4,7.7,12.7z"}));
}

ArrowRoundedLeft8x13.defaultProps = {"width":"8px","height":"13px"};

module.exports = ArrowRoundedLeft8x13;

ArrowRoundedLeft8x13.default = ArrowRoundedLeft8x13;
